module.exports = __webpack_public_path__ + "./img/save-active.8327bcf7c59313f254daf4c218f81049.png";